import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  private isOffline = false;
  private isWeakConnection = false;
  private weakStreak = 0;
  private checkInterval: any;

  constructor(private toastService: ToastService) {
    this.initNetworkListener();
    this.startQualityCheck();
  }

  private async initNetworkListener() {
    Network.addListener('networkStatusChange', async (status) => {
      if (!status.connected) {
        this.handleOffline();
      } else if (this.isOffline) {
        this.handleOnline();
      }
    });
  }

  private startQualityCheck() {
    // Check every 20 seconds instead of 5
    this.checkInterval = setInterval(() => this.performPing(), 20000);
  }

  private async performPing() {
    if (this.isOffline) return;

    const startTime = Date.now();
    try {
      // Smallest possible payload
      await fetch('https://connectivitycheck.gstatic.com/generate_204', {
        method: 'HEAD',
        mode: 'no-cors',
        cache: 'no-store'
      });

      const latency = Date.now() - startTime;

      if (latency > 1500) {
        this.weakStreak++;
        // Notification only after 3 consecutive slow pings
        if (this.weakStreak === 3 && !this.isWeakConnection) {
          this.isWeakConnection = true;
          this.toastService.showWarning('Connexion instable', 'top');
        }
      } else {
        this.weakStreak = 0;
        this.isWeakConnection = false;
        // No toast for "restored" from weak, to keep it quiet
      }
    } catch {
      this.handleOffline();
    }
  }

  private handleOffline() {
    if (!this.isOffline) {
      this.isOffline = true;
      this.isWeakConnection = false;
      this.weakStreak = 0;
      this.toastService.showError('Vous êtes hors ligne', 'top');
    }
  }

  private handleOnline() {
    if (this.isOffline) {
      this.isOffline = false;
      this.toastService.showSuccess('Connexion rétablie !', 'top');
      this.performPing(); // Immediate check
    }
  }
}
